// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Directory
 */
export interface Directory {
  /**
   *
   */
  id: string;
  /**
   *
   */
  type?: DirectoryTypeEnum;
}

/**
 * @export
 */
export const DirectoryTypeEnum = {
  Directory: "directory",
} as const;
export type DirectoryTypeEnum = (typeof DirectoryTypeEnum)[keyof typeof DirectoryTypeEnum];

/**
 * Check if a given object implements the Directory interface.
 */
export function instanceOfDirectory(value: object): value is Directory {
  if (!("id" in value) || value["id"] === undefined) return false;
  return true;
}

export function DirectoryFromJSON(json: any): Directory {
  return DirectoryFromJSONTyped(json, false);
}

export function DirectoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Directory {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    type: json["type"] == null ? undefined : json["type"],
  };
}

export function DirectoryToJSON(json: any): Directory {
  return DirectoryToJSONTyped(json, false);
}

export function DirectoryToJSONTyped(
  value?: Directory | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    type: value["type"],
  };
}
